import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { MfaService } from 'src/app/services/mfa.service';
import { NotificationService } from 'src/app/services/notification.service';

/**
 * MfaSetupComponent is the standalone page an admin reaches after their first
 * password login when MFA is mandatory but not yet configured. It wraps the
 * reusable MfaEnrollComponent with the one-off setup token. After enrollment
 * the user is logged out and sent back to /login to sign in with MFA.
 */
@Component({
  selector: 'app-mfa-setup',
  templateUrl: './mfa-setup.component.html',
  styleUrl: './mfa-setup.component.scss',
})
export class MfaSetupComponent implements OnInit {
  setupToken: string = '';

  constructor(
    private _mfaService: MfaService,
    private _authService: AuthService,
    private _router: Router,
    private _notificationService: NotificationService,
    private _translateService: TranslateService
  ) {}

  ngOnInit(): void {
    // No token (direct navigation or page reload) -> back to login.
    if (!this._mfaService.setupToken) {
      this._router.navigate(['/login']);
      return;
    }
    this.setupToken = this._mfaService.setupToken;
  }

  onDone() {
    this._mfaService.setupToken = '';
    this._authService.reset();
    this._notificationService.addMessage({
      text: this._translateService.instant('mfa.enrolledInfo'),
    });
    this._router.navigate(['/login']);
  }
}
